// src/components/relatorios/GraficoMetaVsRealizado.js
import React from 'react';

function GraficoMetaVsRealizado({ data }) {
  if (!data || !data.meses || data.meses.length === 0) {
    return <div className="grafico-vazio">Nenhum dado disponível</div>;
  }

  const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(valor || 0);
  };

  const formatarMes = (mes) => {
    if (!mes) return '';
    const [ano, mesNum] = mes.split('-');
    const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    return `${meses[parseInt(mesNum) - 1]}/${ano.slice(-2)}`;
  };

  // Encontrar valor máximo para escala
  const valorMaximo = Math.max(
    ...data.meses.map(item => Math.max(item.meta, item.faturado))
  );

  return (
    <div className="grafico-meta-vs-realizado">
      {/* Legenda */}
      <div className="grafico-legenda">
        <div className="legenda-item">
          <div className="legenda-cor" style={{ backgroundColor: '#3b82f6' }}></div>
          <span>Meta</span>
        </div>
        <div className="legenda-item">
          <div className="legenda-cor" style={{ backgroundColor: '#10b981' }}></div>
          <span>Realizado (Atingiu)</span>
        </div>
        <div className="legenda-item">
          <div className="legenda-cor" style={{ backgroundColor: '#ef4444' }}></div>
          <span>Realizado (Não Atingiu)</span>
        </div>
      </div>

      {/* Gráfico */}
      <div className="grafico-barras-meta">
        {/* Linha da meta - ÚNICA para todas as barras */}
        <div 
          className="linha-meta-global"
          style={{ 
            bottom: `${valorMaximo > 0 ? ((data.resumo.meta_mensal / valorMaximo) * 100) : 0}%`,
            borderTop: '2px dashed #3b82f6',
            position: 'absolute',
            left: 0,
            right: 0,
            zIndex: 1
          }}
          title={`Meta: ${formatarValor(data.resumo.meta_mensal)}`}
        />
        
        {data.meses.map((item, index) => {
          const alturaFaturado = valorMaximo > 0 
            ? (item.faturado / valorMaximo * 100)
            : 0;
          
          const corBarra = item.atingiu ? '#10b981' : '#ef4444';
          
          return (
            <div key={index} className="barra-meta-container">
              {/* Barra do faturado */}
              <div 
                className="barra-meta-valor"
                style={{ 
                  height: `${alturaFaturado}%`,
                  backgroundColor: corBarra
                }}
                title={`Faturado: ${formatarValor(item.faturado)} (${item.percentual}%)`}
              >
                {item.faturado > 0 && (
                  <span className="barra-meta-label">
                    {formatarValor(item.faturado)}
                  </span>
                )}
              </div>
              
              {/* Label do mês */}
              <div className="barra-meta-mes">{formatarMes(item.mes)}</div>
              
              {/* Percentual */}
              <div className={`barra-meta-percentual ${item.atingiu ? 'atingiu' : 'nao-atingiu'}`}>
                {item.percentual}%
                {item.atingiu ? ' ✓' : ''}
              </div>
            </div>
          );
        })}
      </div>

      {/* Resumo */}
      <div className="grafico-meta-resumo">
        <div className="resumo-meta-item">
          <span className="resumo-meta-label">Meta Mensal:</span>
          <span className="resumo-meta-valor">{formatarValor(data.resumo.meta_mensal)}</span>
        </div>
        <div className="resumo-meta-item">
          <span className="resumo-meta-label">Meses Atingidos:</span>
          <span className="resumo-meta-valor">
            {data.resumo.meses_atingidos} de {data.resumo.total_meses}
          </span>
        </div>
        <div className="resumo-meta-item destaque">
          <span className="resumo-meta-label">Taxa de Sucesso:</span>
          <span className={`resumo-meta-valor ${data.resumo.taxa_sucesso >= 70 ? 'alta' : data.resumo.taxa_sucesso >= 50 ? 'media' : 'baixa'}`}>
            {data.resumo.taxa_sucesso}%
          </span>
        </div>
      </div>
    </div>
  );
}

export default GraficoMetaVsRealizado;
